import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { utils } from '@atlaskit/util-service-support';
import { CancellablePromise } from '@atlassian/search-client';
import { SpaceContainerType } from '../../common/clients/common-types';
import { timed } from '../../common/clients';
import { SimpleCache } from '../../utils/simple-cache';
import { ConfluenceObjectResult, ConfluenceSpace, GenericContainerResult, RecentConfluence } from './response-types';
export var RECENT_PAGES_PATH = 'rest/recentlyviewed/1.0/recent';
export var RECENT_SPACE_PATH = 'rest/recentlyviewed/1.0/recent/spaces';
var RECENT_PAGES_LIMIT = 200;
var RECENT_SPACE_LIMIT = 5;
export var ConfluenceRecentsClient = /*#__PURE__*/function () {
  function ConfluenceRecentsClient(_ref, collabGraphClient) {
    var _this = this;
    var url = _ref.url,
      isCollaborationGraphEnabled = _ref.isCollaborationGraphEnabled,
      recentItemsSupplier = _ref.recentItemsSupplier,
      useRecentWork = _ref.useRecentWork,
      recentWorkAPIUrl = _ref.recentWorkAPIUrl;
    _classCallCheck(this, ConfluenceRecentsClient);
    _defineProperty(this, "recentItemsSupplier", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$import, createActivityClient, activityClient, _yield$activityClient, viewed, items, baseUrl, recentPagesPromiseWithTimings, _yield$recentPagesPro, result, durationMs, _items;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!_this.useRecentWork) {
              _context.next = 14;
              break;
            }
            _context.next = 3;
            return import( /* webpackChunkName: "@atlaskit-internal_product-search-dialog/recent-work-client" */
            '@atlassian/recent-work-client');
          case 3:
            _yield$import = _context.sent;
            createActivityClient = _yield$import.createActivityClient;
            activityClient = createActivityClient('v3', 'confluence', undefined, _this.recentWorkAPIUrl);
            _context.next = 8;
            return activityClient.fetchActivities([250], {
              products: ['confluence']
            }, ['viewed']);
          case 8:
            _yield$activityClient = _context.sent;
            viewed = _yield$activityClient.viewed;
            items = viewed.filter(function (item) {
              return item.object.product === 'confluence';
            }).map(function (item) {
              return recentWorkItemToResult(item);
            });
            return _context.abrupt("return", {
              items: items,
              totalSize: items.length,
              timings: 0
            });
          case 14:
            baseUrl = _this.serviceConfig.url;
            recentPagesPromiseWithTimings = _this.createRecentRequestPromise(RECENT_PAGES_PATH, {
              limit: RECENT_PAGES_LIMIT
            });
            _context.next = 18;
            return recentPagesPromiseWithTimings;
          case 18:
            _yield$recentPagesPro = _context.sent;
            result = _yield$recentPagesPro.result;
            durationMs = _yield$recentPagesPro.durationMs;
            _items = result.filter(function (page) {
              return !!page.title;
            }).map(function (recentPage) {
              return recentPageToResult(recentPage, baseUrl);
            });
            return _context.abrupt("return", {
              items: _items,
              totalSize: _items.length,
              timings: durationMs
            });
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(this, "recentSpacesSupplier", function () {
      if (_this.isCollabGraphEnabled) {
        return _this.collaborationGraphClient.getContainers([SpaceContainerType]).then(function (response) {
          return mapCollabGraphContainer(response);
        });
      } else {
        var recentSpacesPromise = _this.createRecentRequestPromise(RECENT_SPACE_PATH, {
          limit: RECENT_SPACE_LIMIT
        });
        return recentSpacesPromise.then(function (_ref3) {
          var result = _ref3.result,
            durationMs = _ref3.durationMs;
          return {
            items: result.map(function (recentSpace) {
              return recentSpaceToResult(recentSpace, "".concat(_this.baseUrl, "/spaces/").concat(recentSpace.key));
            }),
            timings: durationMs
          };
        });
      }
    });
    this.serviceConfig = {
      url: url
    };
    this.baseUrl = url;
    this.recentItemCache = new SimpleCache(recentItemsSupplier || this.recentItemsSupplier);
    this.recentSpaceCache = new SimpleCache(this.recentSpacesSupplier);
    this.collaborationGraphClient = collabGraphClient;
    this.isCollabGraphEnabled = isCollaborationGraphEnabled;
    this.useRecentWork = useRecentWork || false;
    this.recentWorkAPIUrl = recentWorkAPIUrl;
  }
  _createClass(ConfluenceRecentsClient, [{
    key: "getRecent",
    value: function getRecent(cache) {
      var _cache$get = cache.get(),
        fromCache = _cache$get.fromCache,
        value = _cache$get.value;
      return CancellablePromise.from(value.then(function (results) {
        return _objectSpread(_objectSpread({}, results), {}, {
          isCached: fromCache
        });
      }));
    }
  }, {
    key: "getRecentItems",
    value: function getRecentItems() {
      return this.getRecent(this.recentItemCache);
    }
  }, {
    key: "getRecentSpaces",
    value: function getRecentSpaces() {
      return this.getRecent(this.recentSpaceCache);
    }
  }, {
    key: "createRecentRequestPromise",
    value: function createRecentRequestPromise(path, queryParams) {
      var options = {
        path: path,
        queryParams: queryParams
      };
      var requestPromise = utils.requestService(this.serviceConfig, options);
      return timed(requestPromise);
    }
  }]);
  return ConfluenceRecentsClient;
}();
function recentWorkItemToResult(recentItem) {
  var object = recentItem.object,
    containers = recentItem.containers;
  return {
    resultId: object.id,
    containerName: containers[0].name,
    containerId: '',
    resultType: ConfluenceObjectResult,
    isRecentResult: true,
    name: object.name || '',
    // Failsafe. All items should have a name.
    href: object.url,
    contentType: "confluence-".concat(object.type),
    lastModified: undefined,
    // not available
    analyticsType: RecentConfluence
  };
}
function recentPageToResult(recentPage, baseUrl) {
  var _recentPage$spaceId;
  return {
    resultId: String(recentPage.id),
    name: recentPage.title || '',
    // This is a failsafe, there should be a filter to drop pages with no titles
    href: "".concat(baseUrl).concat(recentPage.url),
    containerName: recentPage.space,
    analyticsType: RecentConfluence,
    resultType: ConfluenceObjectResult,
    contentType: "confluence-".concat(recentPage.contentType),
    iconClass: recentPage.iconClass,
    containerId: recentPage.spaceId.toString(),
    isRecentResult: true,
    lastModified: undefined,
    // not available for recent results
    spaceId: (_recentPage$spaceId = recentPage.spaceId) === null || _recentPage$spaceId === void 0 ? void 0 : _recentPage$spaceId.toString()
  };
}
function recentSpaceToResult(recentSpace, href) {
  return {
    resultId: recentSpace.id,
    name: recentSpace.name,
    key: recentSpace.key,
    href: href,
    avatarUrl: recentSpace.icon,
    analyticsType: RecentConfluence,
    resultType: GenericContainerResult,
    contentType: ConfluenceSpace,
    id: recentSpace.id
  };
}
function mapCollabGraphContainer(response) {
  var items = response.collaborationGraphEntities.map(function (item) {
    var _item$containerDetail, _item$containerDetail2, _item$containerDetail3, _item$containerDetail4, _item$containerDetail5;
    return {
      id: (_item$containerDetail = item.containerDetails) === null || _item$containerDetail === void 0 ? void 0 : _item$containerDetail.id,
      key: (_item$containerDetail2 = item.containerDetails) === null || _item$containerDetail2 === void 0 ? void 0 : _item$containerDetail2.key,
      icon: (_item$containerDetail3 = item.containerDetails) === null || _item$containerDetail3 === void 0 ? void 0 : _item$containerDetail3.iconUrl,
      name: (_item$containerDetail4 = item.containerDetails) === null || _item$containerDetail4 === void 0 ? void 0 : _item$containerDetail4.name,
      url: (_item$containerDetail5 = item.containerDetails) === null || _item$containerDetail5 === void 0 ? void 0 : _item$containerDetail5.url,
      siteId: item.siteId
    };
  }).filter(function (space) {
    return space.id !== undefined;
  }).map(function (space) {
    return recentSpaceToResult(space, space.url);
  });
  return {
    items: items,
    timings: response.timings
  };
}